// extracted by mini-css-extract-plugin
module.exports = {"changedFoilsList":"ChangedFoilsList_changedFoilsList__2J4IL","changedFoilsItem":"ChangedFoilsList_changedFoilsItem__xRzIF"};